import { render, staticRenderFns } from "./ConsultServicePointsPage.vue?vue&type=template&id=50f2cd3a"
import script from "./ConsultServicePointsPage.vue?vue&type=script&lang=ts"
export * from "./ConsultServicePointsPage.vue?vue&type=script&lang=ts"
import style0 from "./ConsultServicePointsPage.vue?vue&type=style&index=0&id=50f2cd3a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports